/**
 * @generated SignedSource<<e141b2e92ea9b783c53332ba7ad0698e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedStorefrontLink_seller$data = {
  readonly sellerPreferences: {
    readonly storefrontUrl: string | null;
  } | null;
  readonly " $fragmentType": "PdpSharedStorefrontLink_seller";
};
export type PdpSharedStorefrontLink_seller$key = {
  readonly " $data"?: PdpSharedStorefrontLink_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedStorefrontLink_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedStorefrontLink_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerPreferences",
      "kind": "LinkedField",
      "name": "sellerPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "storefrontUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "6af5903d6b3b52579648f492bdce7d2b";

export default node;
